"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _testUtils = _interopRequireDefault(require("react-dom/test-utils"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Simple file input component.<br>
 *
 * This component is a small wrapper around the standard `<input type="file" />`
 * element. It will mask the file input with your provided label so that any
 * node can become a file select trigger.<br>
 *
 * Aside from the documented props any file input props are supported.
 * [Click here](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#Value)
 */
var FileInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FileInput, _React$Component);

  function FileInput(props) {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileInput).call(this, props));

    _this.handleOnClick = function (e) {
      var onClick = _this.origContentProps.onClick;

      if (onClick) {
        onClick(e, _this.inputRef.current);
      }

      _this.inputRef.current.click();
    };

    _this.handleOnChange = function (e) {
      var _this$props = _this.props,
          onFileChange = _this$props.onFileChange,
          onChange = _this$props.onChange;
      var currentTarget = e.currentTarget;

      if (currentTarget.files && currentTarget.files.length) {
        if (onFileChange) {
          onFileChange(e.currentTarget.files);
        }

        if (onChange) {
          onChange(e);
        }
      }
    };

    _this.handleOnDragOver = function (e) {
      var onDragOver = _this.origContentProps.onDragOver;
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';

      if (onDragOver) {
        onDragOver(e);
      }
    };

    _this.handleOnDrop = function (e) {
      var onDrop = _this.origContentProps.onDrop;
      e.stopPropagation();
      e.preventDefault();
      var onFileChange = _this.props.onFileChange;

      if (onFileChange) {
        onFileChange(e.dataTransfer.files);
      }

      if (onDrop) {
        onDrop(e);
      }
    };

    _this.inputRef = props.inputRef || _react.default.createRef(); // Use to store the original props.content props.

    _this.origContentProps = {};
    return _this;
  }
  /**
   * This is to handle when the props.content node is clicked.
   * By default this will trigger a click to the input causing the
   * browser to present a files dialog box.
   * @param {InputEvent} e: this is the input tag event.
   */


  _createClass(FileInput, [{
    key: "_getContentProps",

    /**
     * Generate the proper content props based on the defined props.
     * @private
     * @return {object} - Property object.
     */
    value: function _getContentProps() {
      var _this$props2 = this.props,
          enableFileSelect = _this$props2.enableFileSelect,
          enableDragDrop = _this$props2.enableDragDrop;
      var addContentProps = {};

      if (enableDragDrop) {
        addContentProps.onDragOver = this.handleOnDragOver;
        addContentProps.onDrop = this.handleOnDrop;
      }

      if (enableFileSelect) {
        addContentProps.onClick = this.handleOnClick;
      }

      return addContentProps;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          content = _this$props3.content,
          children = _this$props3.children,
          onFileChange = _this$props3.onFileChange,
          type = _this$props3.type,
          inputRef = _this$props3.inputRef,
          onChange = _this$props3.onChange,
          enableFileSelect = _this$props3.enableFileSelect,
          enableDragDrop = _this$props3.enableDragDrop,
          props = _objectWithoutProperties(_this$props3, ["className", "content", "children", "onFileChange", "type", "inputRef", "onChange", "enableFileSelect", "enableDragDrop"]);

      var addContentProps = this._getContentProps();

      var contentNode;

      if (_testUtils.default.isElement(content)) {
        this.origContentProps = content.props;
        contentNode = _react.default.cloneElement(content, addContentProps);
      } else {
        // string or number
        contentNode = _react.default.createElement("span", addContentProps, content);
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), " ").concat(_ThemeManager.default.getVar('classPrefix'), "-file-input"))
      }, contentNode, _react.default.createElement("input", _extends({
        ref: this.inputRef,
        type: "file",
        onChange: this.handleOnChange
      }, props)));
    }
  }]);

  return FileInput;
}(_react.default.Component);

exports.default = FileInput;
FileInput.defaultProps = {
  enableDragDrop: true,
  enableFileSelect: true
};
FileInput.propTypes = {
  /**
   * This is the node content that will be wrap with file input functionality.
   */
  content: _propTypes.default.node.isRequired,

  /**
   * This is triggered every time files are selected or drag and drop into the component
   * Use this instead of onChange.
   * onFileChange(files)
   * @param {FileList} files: instance of FileList
   */
  onFileChange: _propTypes.default.func,

  /**
   * Set to false to disable drap drop support.
   */
  enableDragDrop: _propTypes.default.bool,

  /**
   * By default clicking on the props.content will open system file dialog box.
   * Set to false disable this feature.
   */
  enableFileSelect: _propTypes.default.bool,

  /**
   * This provides a way for you to get a reference to the `<input>` dom node.
   * It can be a callback function or an object from React.createRef().
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func])
};